import React from 'react';
import { useNavigate } from 'react-router-dom';

import { ModalFlowContext } from '@/types/modalFlowContext';

export const useFlowContext = (parentPath: string): ModalFlowContext => {
  const navigate = useNavigate();

  return React.useMemo((): ModalFlowContext => {
    return {
      closePath: parentPath,
      close: (state?: unknown): void => {
        if (typeof parentPath === 'number') {
          navigate(parentPath);
        } else {
          navigate(parentPath, { replace: true, state: state });
        }
      },
    };
  }, [navigate, parentPath]);
};
